export default function TypingIndicator() {
  return (
    <div className="chat-typing">
      <div className="chat-message assistant">
        <div className="typing-dots">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
